import { HOURS } from './actions'

// The screens kept: enough for this week, the next days and the planning.
const MAX_CACHED = 40
const MAX_REJECTED = 10

const initialState = {
  userId:   null,
  cache:    {},
  outbox:   [],
  rejected: [],
}

const prune = cache => {
  const keys = Object.keys(cache)
  if (keys.length <= MAX_CACHED) return cache

  const kept = keys.sort((a, b) => (cache[b].at || '').localeCompare(cache[a].at || '')).slice(0, MAX_CACHED)
  return kept.reduce((result, key) => ({ ...result, [key]: cache[key] }), {})
}

export default function hoursReducer(state = initialState, action) {
  switch (action.type) {

    case HOURS.OWNER:
      return action.userId === state.userId ? state : { ...initialState, userId: action.userId }

    case HOURS.CACHE:
      return { ...state, cache: prune({ ...state.cache, [action.key]: { payload: action.payload, at: action.at } }) }

    case HOURS.ENQUEUE:
      return { ...state, outbox: [...state.outbox, action.item] }

    case HOURS.REPLACE:
      return { ...state, outbox: state.outbox.map(item => (item.id === action.id ? { ...item, ...action.patch } : item)) }

    case HOURS.DROP:
      return { ...state, outbox: state.outbox.filter(item => !action.ids.includes(item.id)) }

    case HOURS.REJECT: {
      const item = state.outbox.find(candidate => candidate.id === action.id)
      if (!item) return state
      const rejected = [...state.rejected, { id: item.id, date: item.date, label: item.label, message: action.message, at: action.at }]
      return { ...state, outbox: state.outbox.filter(candidate => candidate.id !== action.id), rejected: rejected.slice(-MAX_REJECTED) }
    }

    case HOURS.DISMISS:
      return { ...state, rejected: state.rejected.filter(item => item.id !== action.id) }

    default:
      return state
  }
}
